import React from 'react';

// DEPENDENCIES
import { useNavigate, useParams } from 'react-router-dom';

// GLOBAL VARIABLES
import { INTERFACE, RECORD } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';

// MAIN COMPONENT
const ReviveButton = () => {
  const navigate = useNavigate();
  const { recordID } = useParams();

  return (
    <Button
      onClick={() => navigate(makePath(INTERFACE.sales, RECORD.edit, recordID), { state: { revive: true } })}
      outline
      fullWidth={false}
      label="Revive"
      size="sm"
    />
  );
};

// EXPORT
export default ReviveButton;
